import { api } from "..";

export function createProductRequest(data) {
  return api.post("/v1/product/create", data);
}

export function updateProductRequest({ id, data }) {
  return api.put(`/v1/product/${id}`, data);
}

export function getProductRequest({ params }) {
  return api.get(`/v1/product`, {
    params,
  });
}

export function getProductByIdRequest({ id, params }) {
  return api.get(`/v1/product/${id}`, { params });
}

export function createProductImportRequest({ productId, data }) {
  return api.post(`/v1/product/${productId}/import`, data);
}
